import React, {FC} from 'react';

import {UnreachableError} from '../../../../../../libs/shared/helpers/src/types/customErrors';
import {PaletteColorsEnum} from '../../../../../../libs/shared/ui/src/styles/paletteModel';
import {HighlightTypesEnum} from '../../../../../models/api/highlightBaseModel';
import {TagModel} from '../../../../../models/api/tagModel';
import {CellTagColor} from './cellTagColor';
import {CellTagEmoji} from './cellTagEmoji';

/*
 * Props.
 */

interface CellTagsProps {
  tags: ReadonlyArray<TagModel>;
}

/*
 * Component.
 */

export const CellTags: FC<CellTagsProps> = (props) => (
  <>
    {props.tags.map((t) => {
      switch (t.type) {
        case HighlightTypesEnum.EMOJI:
          return <CellTagEmoji key={t.id} tag={t} />;

        case HighlightTypesEnum.COLOR:
          return <CellTagColor key={t.id} name={t.name} color={t.highlightColor} />;

        case HighlightTypesEnum.NONE:
          return <CellTagColor key={t.id} name={t.name} color={PaletteColorsEnum.GREY} />;

        default:
          throw new UnreachableError(t);
      }
    })}
  </>
);
